export const NO_ROUNDING = "NO_ROUNDING";
export const ONE_TENTH = "ONE_TENTH";
export const ONE_HUNDREDTH = "ONE_HUNDREDTH";
export const ONE_THOUSANDTH = "ONE_THOUSANDTH";
export const ONE_TEN_THOUSANDTH = "ONE_TEN_THOUSANDTH";
export const ONE_EIGTH = "ONE_EIGTH";
export const ONE_SIXTEENTH = "ONE_SIXTEENTH";
export const ONE_THIRTY_SECOND = "ONE_THIRTY_SECOND";
export const ONE_SIXTY_FOURTH = "ONE_SIXTY_FOURTH";

export default {
  NO_ROUNDING,
  ONE_TENTH,
  ONE_HUNDREDTH,
  ONE_THOUSANDTH,
  ONE_TEN_THOUSANDTH,
  ONE_EIGTH,
  ONE_SIXTEENTH,
  ONE_THIRTY_SECOND,
  ONE_SIXTY_FOURTH
};
